import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-51">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-52">
        <img src="https://cdn.magicpatterns.com/uploads/7W8sTA7LFxbjZeuLPKumRo/mike-curry-hero.png" alt="Mike Curry sitting on a cliff at sunrise" className="w-full h-full object-cover object-center" data-id="element-53" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-charcoal" data-id="element-54"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-56">
          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl text-white leading-tight mb-6 drop-shadow-lg" data-id="element-57">
            You Look Successful.
            <br data-id="element-58" />
            <span className="text-gold" data-id="element-59">
              But You're Barely Holding It Together.
            </span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} data-id="element-60">
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-10 leading-relaxed font-light" data-id="element-61">
            For entrepreneurs, business owners, and sales professionals who look
            like they have it all — but feel stuck, overwhelmed, or spiritually
            empty on the inside.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} data-id="element-62">
          <a href="#contact" className="inline-block bg-gold hover:bg-gold-light text-black font-bold text-lg py-4 px-10 rounded-sm uppercase tracking-widest transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(200,150,62,0.3)]" data-id="element-63">
            Book a Free Strategy Session
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10" data-id="element-64">
        <div className="flex flex-col items-center text-gray-400" data-id="element-65">
          <span className="text-xs uppercase tracking-widest mb-2" data-id="element-66">Scroll</span>
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} data-id="element-67">
            <ChevronDown size={24} data-id="element-68" />
          </motion.div>
        </div>
      </motion.div>
    </section>;
}